import React from "react";
import { Dialog } from "@material-ui/core";
import DialogToolbar from "./DialogToolbar";
import { DialogMaxWidth, getDialogBackdropProps, getDialogLayout } from "../../consts/dialog";
import DialogPresentationContext from "./DialogPresentationContext";

type MaxWidthType = DialogMaxWidth;

let showDialog = (
  _content: React.ReactNode,
  _maxWidth: MaxWidthType,
  _fullScreen: boolean,
  _backDropClickToClose?: boolean,
  _toolbar?: boolean,
  _title?: string,
  _logo?: string,
  _onClose?: () => void,
  _subtitle?: string,
  _showTrophy?: boolean,
): void => {};

let hideDialog = (): void => {};

let updateDialogMeta = (
  _title?: string,
  _subtitle?: string,
  _showTrophy?: boolean,
  _statusLabel?: string,
): void => {};

interface State {
  content: React.ReactNode;
  open: boolean;
  title: string;
  logo: string;
  className: string;
  fullScreen: boolean;
  fullWidth: boolean;
  maxWidth: MaxWidthType;
  paperStyle?: React.CSSProperties;
  backDropClickToClose: boolean;
  toolbar: boolean;
  onClose?: () => void;
  subtitle: string;
  statusLabel: string;
  showTrophy: boolean;
}

class _Dialog extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = {
      title: "",
      logo: "",
      content: null,
      maxWidth: "md",
      open: false,
      className: "",
      fullScreen: false,
      fullWidth: true,
      paperStyle: undefined,
      backDropClickToClose: false,
      toolbar: false,
      subtitle: "",
      statusLabel: "",
      showTrophy: false,
    };
  }

  componentDidMount() {
    showDialog = this.showDialog;
    hideDialog = this.closeDialog;
    updateDialogMeta = this.updateDialogMeta;
  }

  updateDialogMeta = (title = "", subtitle = "", showTrophy = false, statusLabel = "") => {
    if (!this.state.open) return;
    this.setState({ title, subtitle, showTrophy, statusLabel });
  };

  showDialog = (
    content: React.ReactNode,
    maxWidth: MaxWidthType,
    fullScreen: boolean,
    backDropClickToClose?: boolean,
    toolbar?: boolean,
    title?: string,
    logo?: string,
    onClose?: () => void,
    subtitle?: string,
    showTrophy?: boolean,
  ) => {
    const layout = getDialogLayout({ maxWidth, fullScreen });

    this.setState({
      open: true,
      content,
      fullScreen: layout.fullScreen,
      fullWidth: layout.fullWidth,
      maxWidth: layout.maxWidth,
      paperStyle: layout.paperStyle,
      backDropClickToClose: Boolean(backDropClickToClose),
      toolbar: Boolean(toolbar),
      title: title || "",
      logo: logo || "",
      onClose,
      subtitle: subtitle || "",
      showTrophy: showTrophy ?? false,
    });
  };

  closeDialog = () => {
    this.state.onClose?.();
    this.setState({ open: false });
  };

  render() {
    const {
      className,
      maxWidth,
      open,
      content,
      backDropClickToClose,
      toolbar,
      title,
      logo,
      subtitle,
      statusLabel,
      showTrophy,
      fullScreen,
      fullWidth,
      paperStyle,
    } = this.state;

    return (
      <Dialog
        open={open}
        scroll="paper"
        className={className}
        disableEnforceFocus
        onBackdropClick={backDropClickToClose ? this.closeDialog : undefined}
        maxWidth={maxWidth}
        fullWidth={fullWidth}
        fullScreen={fullScreen}
        BackdropProps={getDialogBackdropProps()}
        PaperProps={paperStyle ? { style: paperStyle } : undefined}
      >
        <DialogPresentationContext.Provider value={{ isFullscreen: fullScreen }}>
          {toolbar ? (
            <DialogToolbar
              logo={logo}
              border={!logo}
              title={title}
              subtitle={subtitle}
              statusLabel={statusLabel}
              showTrophy={showTrophy}
              onClick={this.closeDialog}
            />
          ) : null}
          {content}
        </DialogPresentationContext.Provider>
      </Dialog>
    );
  }
}

export { showDialog, hideDialog, updateDialogMeta };
export default _Dialog;
